import React from 'react';
import { Hero } from './components/Hero';
import { AboutFlorencia } from './components/AboutFlorencia';
import { Benefits } from './components/Benefits';
import { WhyDietsFail } from './components/WhyDietsFail';
import { BonusesIncluded } from './components/BonusesIncluded';
import { Testimonials } from './components/Testimonials';
import { Guarantee } from './components/Guarantee';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { MetaPixel } from './components/MetaPixel';
export function App() {
  return <div className="min-h-screen bg-brand-cream selection:bg-brand-sage/30" data-id="element-0">
      <MetaPixel data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <AboutFlorencia data-id="element-4" />
        <Benefits data-id="element-5" />
        <WhyDietsFail data-id="element-6" />
        <BonusesIncluded data-id="element-7" />
        <Testimonials data-id="element-8" />
        <Guarantee data-id="element-9" />
        <FinalCTA data-id="element-10" />
      </main>
      <Footer data-id="element-11" />
    </div>;
}